import { render } from "./HomeBody1.vue?vue&type=template&id=421c3709&scoped=true"
import script from "./HomeBody1.vue?vue&type=script&lang=js"
export * from "./HomeBody1.vue?vue&type=script&lang=js"

import "./HomeBody1.vue?vue&type=style&index=0&id=421c3709&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421c3709"]])

export default __exports__